import { useEffect } from 'react';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[600px] bg-gradient-to-br from-teal-500 via-blue-500 to-cyan-600 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c1a0115949f372cc01761b4c699c47d7.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.4
        }}></div>
        <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold mb-6 drop-shadow-lg">關於我們</h1>
          <p className="text-2xl md:text-3xl font-light mb-4">海洋夢想家 Ocean Dreamer</p>
          <p className="text-xl md:text-2xl mt-6 font-medium">離海5min - 您的墾丁海洋體驗專家</p>
          <p className="text-lg md:text-xl mt-4 text-white/90">專業、安全、難忘的海洋冒險之旅</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="max-w-7xl mx-auto px-4 py-20">
        <div className="space-y-20">
          {/* Brand Info */}
          <div className="bg-gradient-to-br from-teal-50 via-blue-50 to-cyan-50 rounded-3xl p-12 md:p-20 shadow-xl">
            <h2 className="text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-blue-600 mb-12 text-center">離海5min</h2>
            <p className="text-center text-xl text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed">
              位於墾丁後壁湖，距離海邊僅需5分鐘，是您體驗海洋活動與享受海景住宿的最佳選擇
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-6 shadow-md">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Instagram%20social%20media%20app%20icon%20logo%20in%20pink%20and%20purple%20gradient%20colors%2C%20official%20brand%20design%2C%20square%20format%20with%20rounded%20corners%2C%20modern%20minimalist%20style%2C%20high%20quality%20digital%20illustration%2C%20clean%20white%20background%2C%20professional%20branding&width=200&height=200&seq=instagram-icon-about&orientation=squarish"
                    alt="Instagram"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-sm text-gray-600 mb-3 text-center">Instagram</p>
                <p className="font-bold text-gray-900 text-lg text-center">5min_to_sea</p>
                <a 
                  href="https://www.instagram.com/5min_to_sea/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block mt-4 text-center text-pink-600 hover:text-pink-700 text-sm cursor-pointer"
                >
                  追蹤我們 →
                </a>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-6 shadow-md">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Facebook%20social%20media%20app%20icon%20logo%20in%20blue%20color%2C%20official%20brand%20design%2C%20square%20format%20with%20rounded%20corners%2C%20modern%20minimalist%20style%2C%20high%20quality%20digital%20illustration%2C%20clean%20white%20background%2C%20professional%20branding&width=200&height=200&seq=facebook-icon-about&orientation=squarish"
                    alt="Facebook"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-sm text-gray-600 mb-3 text-center">Facebook</p>
                <p className="font-bold text-gray-900 text-lg text-center">離海5min / 5 mins to Sea</p>
                <a 
                  href="https://www.facebook.com/5mintosea" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block mt-4 text-center text-blue-600 hover:text-blue-700 text-sm cursor-pointer"
                >
                  按讚追蹤 →
                </a>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-6 shadow-md">
                  <img 
                    src="https://readdy.ai/api/search-image?query=LINE%20messaging%20app%20icon%20logo%20in%20green%20color%2C%20official%20brand%20design%2C%20square%20format%20with%20rounded%20corners%2C%20modern%20minimalist%20style%2C%20high%20quality%20digital%20illustration%2C%20clean%20white%20background%2C%20professional%20branding&width=200&height=200&seq=line-icon-about&orientation=squarish"
                    alt="LINE"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-sm text-gray-600 mb-3 text-center">LINE ID</p>
                <p className="font-bold text-gray-900 text-lg text-center">@736dwpdn</p>
                <a 
                  href="https://lin.ee/9FBUBrH" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block mt-4 text-center text-green-600 hover:text-green-700 text-sm cursor-pointer"
                >
                  加入好友 →
                </a>
              </div>
            </div>
          </div>

          {/* Introduction */}
          <div className="prose prose-lg max-w-none">
            <div className="bg-white rounded-3xl p-12 md:p-20 shadow-xl border-2 border-gray-100">
              <div className="flex items-center justify-center mb-10">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-3xl text-white"></i>
                </div>
              </div>
              <h3 className="text-4xl font-bold text-gray-900 mb-10 text-center">我們的故事</h3>
              <div className="space-y-8 text-gray-700 text-lg leading-relaxed">
                <p className="text-xl">
                  位在南台灣的<strong className="text-teal-600 text-2xl">墾丁後壁湖</strong>地區，由一群熱愛海洋的運動玩家所組成。
                </p>
                <p>
                  本團隊長期與<strong className="text-blue-600">國立高雄海洋科技大學</strong>、<strong className="text-blue-600">國立中山大學</strong>、<strong className="text-blue-600">海洋委員會</strong>、<strong className="text-blue-600">中華民國輕艇協會</strong>等相關單位合作，在水域活動經驗及知識技能的培養下，孕育出扎實的專業能力。
                </p>
                <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 my-8">
                  <p className="text-xl font-semibold text-center text-gray-800">
                    我們整合海洋資源及周遭環境，期望能為臺灣水域活動及觀光產業盡一份心力
                  </p>
                </div>
                <p>
                  讓大家得以<strong className="text-teal-600">從遊玩中學習，從學習中玩出心得</strong>，同時也能帶給來體驗的各位<strong className="text-blue-600 text-xl">安全、有趣及難忘的墾丁之旅</strong>。
                </p>
              </div>
            </div>
          </div>

          {/* Services Highlight */}
          <div className="relative overflow-hidden bg-gradient-to-br from-teal-500 via-blue-500 to-cyan-600 rounded-3xl p-12 md:p-20 text-white shadow-2xl">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full -ml-48 -mb-48"></div>
            <div className="relative z-10">
              <div className="text-center mb-16">
                <p className="text-2xl md:text-3xl mb-6 font-light">除了提供</p>
                <h2 className="text-5xl md:text-6xl font-bold mb-10">豐富的套裝行程</h2>
              </div>
              <div className="max-w-4xl mx-auto">
                <p className="text-2xl md:text-3xl leading-relaxed mb-12 text-center font-light">
                  我們專業的教練也將為您在活動中
                </p>
                <div className="bg-white/25 backdrop-blur-md rounded-3xl p-10 mb-12 shadow-xl">
                  <h3 className="text-3xl md:text-4xl font-bold text-center leading-relaxed">
                    進行後壁湖的海底生態導覽<br />和當地的文化介紹
                  </h3>
                </div>
                <p className="text-2xl md:text-3xl text-center font-bold">
                  讓您的旅程能夠多采多姿！
                </p>
                <div className="grid md:grid-cols-3 gap-6 mt-12">
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 text-center">
                    <div className="w-16 h-16 bg-white/30 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-water-flash-line text-3xl"></i>
                    </div>
                    <p className="font-semibold text-lg">專業水域活動</p>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 text-center">
                    <div className="w-16 h-16 bg-white/30 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-fish-line text-3xl"></i>
                    </div>
                    <p className="font-semibold text-lg">海洋生態導覽</p>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 text-center">
                    <div className="w-16 h-16 bg-white/30 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-map-pin-line text-3xl"></i>
                    </div>
                    <p className="font-semibold text-lg">在地文化體驗</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Qualifications */}
          <div>
            <div className="text-center mb-12">
              <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">專業團隊保證</h3>
              <p className="text-xl text-gray-600">經驗豐富 · 證照齊全 · 值得信賴</p>
            </div>
            <div className="grid md:grid-cols-2 gap-10">
              <div className="bg-gradient-to-br from-amber-500 to-orange-500 rounded-3xl p-12 text-white shadow-2xl hover:shadow-3xl transition-all hover:scale-105">
                <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-8">
                  <i className="ri-medal-line text-6xl"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold mb-6">專業證照齊全</h3>
                <p className="text-xl leading-relaxed text-white/95 mb-6">
                  全團隊成員已獲得了<strong className="text-2xl">數張水域教練證照</strong>，包括潛水、獨木舟、SUP等多項專業認證
                </p>
                <p className="text-lg text-white/90">
                  確保每一次活動都在專業指導下安全進行
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-3xl p-12 text-white shadow-2xl hover:shadow-3xl transition-all hover:scale-105">
                <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-8">
                  <i className="ri-trophy-line text-6xl"></i>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold mb-6">豐富活動經驗</h3>
                <p className="text-xl leading-relaxed text-white/95 mb-6">
                  擁有<strong className="text-2xl">許多舉辦大型活動的經驗</strong>，服務過數千位來自世界各地的旅客
                </p>
                <p className="text-lg text-white/90">
                  能夠應對各種情況，給您最佳體驗
                </p>
              </div>
            </div>
          </div>

          {/* Promise */}
          <div className="bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50 rounded-3xl p-12 md:p-20 text-center shadow-xl">
            <div className="max-w-4xl mx-auto">
              <div className="mb-10">
                <div className="inline-block bg-gradient-to-r from-teal-500 to-blue-500 text-white rounded-full px-8 py-3 text-lg font-semibold">
                  我們的承諾
                </div>
              </div>
              <p className="text-2xl md:text-3xl text-gray-800 leading-relaxed mb-10">
                一定能帶給您最安全及最有趣的體驗，並留下
              </p>
              <div className="inline-block bg-gradient-to-r from-teal-500 via-blue-500 to-cyan-500 text-white rounded-3xl px-16 py-10 shadow-2xl transform hover:scale-105 transition-transform">
                <h3 className="text-5xl md:text-6xl font-bold mb-4">最難忘的回憶！</h3>
                <p className="text-xl md:text-2xl font-light">Unforgettable Memories</p>
              </div>
              <div className="grid md:grid-cols-3 gap-6 mt-12">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-3xl text-teal-600"></i>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">安全第一</h4>
                  <p className="text-gray-600">完善的安全措施與專業指導</p>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-emotion-happy-line text-3xl text-blue-600"></i>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">趣味體驗</h4>
                  <p className="text-gray-600">豐富多元的海洋活動選擇</p>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-heart-line text-3xl text-cyan-600"></i>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">用心服務</h4>
                  <p className="text-gray-600">貼心細緻的全程陪伴</p>
                </div>
              </div>
            </div>
          </div>

          {/* Accommodation Notice */}
          <div className="relative overflow-hidden bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 rounded-3xl p-12 md:p-20 text-center text-white shadow-2xl">
            <div className="absolute inset-0 bg-black/10"></div>
            <div className="absolute top-0 left-0 w-72 h-72 bg-white/10 rounded-full -ml-36 -mt-36"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full -mr-48 -mb-48"></div>
            <div className="relative z-10">
              <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-10 py-4 mb-8">
                <p className="text-2xl md:text-3xl font-semibold">By the way,</p>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold mb-8 leading-relaxed">
                自2024年開始<br />我們也提供住宿啦！
              </h3>
              <p className="text-3xl md:text-4xl font-bold mb-6">
                快快洽詢享優惠～
              </p>
              <p className="text-xl md:text-2xl mb-10 text-white/90 max-w-2xl mx-auto">
                結合海洋活動與舒適住宿，讓您的墾丁之旅更加完整便利
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-white text-purple-600 font-bold text-xl px-12 py-5 rounded-full hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap transform hover:scale-105"
                >
                  <i className="ri-hotel-bed-line mr-2"></i>
                  查看住宿方案
                </a>
                <a 
                  href="https://lin.ee/i6pwzIh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-500 text-white font-bold text-xl px-12 py-5 rounded-full hover:bg-green-600 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap transform hover:scale-105"
                >
                  <i className="ri-line-fill mr-2"></i>
                  LINE 訂房諮詢
                </a>
              </div>
            </div>
          </div>

          {/* Contact Links */}
          <div>
            <div className="text-center mb-12">
              <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">快速聯絡</h3>
              <p className="text-xl text-gray-600">隨時為您服務，歡迎諮詢</p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <a 
                href="https://lin.ee/9FBUBrH" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white border-2 border-gray-200 hover:border-green-500 hover:shadow-2xl rounded-3xl p-10 text-center transition-all cursor-pointer group transform hover:scale-105"
              >
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-green-500 transition-colors">
                  <i className="ri-chat-3-line text-4xl text-green-600 group-hover:text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-3">活動官方LINE</h4>
                <p className="text-gray-600 text-lg mb-2">@736dwpdn</p>
                <p className="text-sm text-gray-500 mb-4">水上活動諮詢</p>
                <div className="inline-block bg-green-50 text-green-600 px-4 py-2 rounded-full text-sm font-semibold group-hover:bg-green-500 group-hover:text-white transition-colors">
                  立即諮詢 →
                </div>
              </a>

              <a 
                href="https://lin.ee/i6pwzIh" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white border-2 border-gray-200 hover:border-teal-500 hover:shadow-2xl rounded-3xl p-10 text-center transition-all cursor-pointer group transform hover:scale-105"
              >
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-teal-500 transition-colors">
                  <i className="ri-hotel-bed-line text-4xl text-teal-600 group-hover:text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-3">B&B 官方LINE</h4>
                <p className="text-gray-600 text-lg mb-2">住宿專線</p>
                <p className="text-sm text-gray-500 mb-4">訂房諮詢</p>
                <div className="inline-block bg-teal-50 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold group-hover:bg-teal-500 group-hover:text-white transition-colors">
                  預訂住宿 →
                </div>
              </a>

              <a 
                href="https://www.instagram.com/5min_to_sea_bnb/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white border-2 border-gray-200 hover:border-pink-500 hover:shadow-2xl rounded-3xl p-10 text-center transition-all cursor-pointer group transform hover:scale-105"
              >
                <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-pink-500 transition-colors">
                  <i className="ri-instagram-line text-4xl text-pink-600 group-hover:text-white"></i>
                </div>
                <h4 className="font-bold text-2xl text-gray-900 mb-3">B&B Instagram</h4>
                <p className="text-gray-600 text-lg mb-2">5min_to_sea_bnb</p>
                <p className="text-sm text-gray-500 mb-4">最新動態</p>
                <div className="inline-block bg-pink-50 text-pink-600 px-4 py-2 rounded-full text-sm font-semibold group-hover:bg-pink-500 group-hover:text-white transition-colors">
                  追蹤我們 →
                </div>
              </a>
            </div>
          </div>

          {/* Additional Links */}
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12 md:p-20">
            <h3 className="text-4xl font-bold text-gray-900 mb-10 text-center">更多資訊</h3>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <a 
                href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white hover:bg-teal-50 border-2 border-gray-200 hover:border-teal-500 rounded-2xl p-8 flex items-center gap-6 transition-all cursor-pointer group shadow-md hover:shadow-xl"
              >
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-teal-500 transition-colors">
                  <i className="ri-calendar-check-line text-3xl text-teal-600 group-hover:text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-xl text-gray-900 mb-2">B&B 訂房專區</h4>
                  <p className="text-gray-600">線上預訂住宿，即時確認</p>
                </div>
              </a>

              <a 
                href="mailto:2019oceandreamer@gmail.com"
                className="bg-white hover:bg-blue-50 border-2 border-gray-200 hover:border-blue-500 rounded-2xl p-8 flex items-center gap-6 transition-all cursor-pointer group shadow-md hover:shadow-xl"
              >
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500 transition-colors">
                  <i className="ri-mail-line text-3xl text-blue-600 group-hover:text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-xl text-gray-900 mb-2">Email 聯絡</h4>
                  <p className="text-gray-600 text-sm break-all">2019oceandreamer@gmail.com</p>
                </div>
              </a>
            </div>
          </div>

          {/* CTA Section */}
          <div className="relative overflow-hidden text-center bg-gradient-to-r from-teal-500 via-blue-500 to-cyan-500 rounded-3xl p-12 md:p-20 shadow-2xl">
            <div className="absolute inset-0 bg-black/5"></div>
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full -mr-48 -mt-48"></div>
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-white/10 rounded-full -ml-36 -mb-36"></div>
            <div className="relative z-10">
              <div className="inline-block bg-white/20 backdrop-blur-sm rounded-full px-8 py-3 mb-6">
                <p className="text-lg font-semibold text-white">Ready to Dive In?</p>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">準備好開始您的海洋冒險了嗎？</h3>
              <p className="text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto">
                立即預訂，享受難忘的墾丁之旅<br />
                專業團隊為您打造最完美的海洋體驗
              </p>
              <div className="flex flex-col sm:flex-row gap-6 justify-center">
                <a 
                  href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-white text-teal-600 hover:bg-gray-100 font-bold text-xl px-12 py-5 rounded-full transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap transform hover:scale-105"
                >
                  <i className="ri-hotel-bed-line mr-2"></i>
                  立即預訂住宿
                </a>
                <a 
                  href="https://lin.ee/9FBUBrH"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-green-500 text-white hover:bg-green-600 font-bold text-xl px-12 py-5 rounded-full transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap transform hover:scale-105"
                >
                  <i className="ri-line-fill mr-2"></i>
                  LINE 諮詢活動
                </a>
              </div>
              <p className="text-white/80 mt-8 text-lg">
                💙 期待與您在墾丁相遇，共創美好回憶！
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}